const triggers = [...document.querySelectorAll('.js-size-table-trigger')];

triggers.map(trigger => {
    const key = trigger.dataset.key;

    trigger.addEventListener('click', () => {
        const target = document.querySelector(`.js-size-table[data-key="${key}"]`);


        if(target) {
            if(target.classList.contains('size-table--open')) {
                target.classList.remove('size-table--open');
            } else {
                target.classList.add('size-table--open');
            }
        }else {
            target.classList.remove('size-table--open');
        }
    });
})
